export interface ModelDetailedResultExpensesPayload {
  id?: number;
  modelDetailedResult?: number;
  expenseType?: number;
  expenseDetail?: string;
  expenseAmount?: number;
  exceededAmount?: number;
  expenseSplitable?: boolean;
  expensePeriodFrom?: string;
  expensePeriodTo?: string;
  expensePeriodDays?: number;
  comments?: string;
  prorratedExpense?: number;
  expenseNumber?: number;
  flagClone?: boolean;
  expenseAccessory?: string;
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function toBoolean(value: unknown): boolean | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return undefined;
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  const text = String(value).trim();
  return text.length > 0 ? text : undefined;
}

export function buildModelDetailedResultExpensesPayload(input: any): ModelDetailedResultExpensesPayload {
  const payload: ModelDetailedResultExpensesPayload = {};

  const id = toNumber(input?.id);
  if (id !== undefined) payload.id = id;

  const modelDetailedResult = toNumber(input?.modelDetailedResult);
  if (modelDetailedResult !== undefined) payload.modelDetailedResult = modelDetailedResult;

  const expenseType = toNumber(input?.expenseType);
  if (expenseType !== undefined) payload.expenseType = expenseType;

  const expenseDetail = toStringValue(input?.expenseDetail);
  if (expenseDetail !== undefined) payload.expenseDetail = expenseDetail;

  const expenseAmount = toNumber(input?.expenseAmount);
  if (expenseAmount !== undefined) payload.expenseAmount = expenseAmount;

  const exceededAmount = toNumber(input?.exceededAmount);
  if (exceededAmount !== undefined) payload.exceededAmount = exceededAmount;

  const expenseSplitable = toBoolean(input?.expenseSplitable);
  if (expenseSplitable !== undefined) payload.expenseSplitable = expenseSplitable;

  const expensePeriodFrom = toStringValue(input?.expensePeriodFrom);
  if (expensePeriodFrom !== undefined) payload.expensePeriodFrom = expensePeriodFrom;

  const expensePeriodTo = toStringValue(input?.expensePeriodTo);
  if (expensePeriodTo !== undefined) payload.expensePeriodTo = expensePeriodTo;

  const expensePeriodDays = toNumber(input?.expensePeriodDays);
  if (expensePeriodDays !== undefined) payload.expensePeriodDays = expensePeriodDays;

  const comments = toStringValue(input?.comments);
  if (comments !== undefined) payload.comments = comments;

  const prorratedExpense = toNumber(input?.prorratedExpense);
  if (prorratedExpense !== undefined) payload.prorratedExpense = prorratedExpense;

  const expenseNumber = toNumber(input?.expenseNumber);
  if (expenseNumber !== undefined) payload.expenseNumber = expenseNumber;

  const flagClone = toBoolean(input?.flagClone);
  if (flagClone !== undefined) payload.flagClone = flagClone;

  const expenseAccessory = toStringValue(input?.expenseAccessory);
  if (expenseAccessory !== undefined) payload.expenseAccessory = expenseAccessory;

  return payload;
}
